<template>
  <shipment-tracking v-if="!!shipmentData"/>
  <shipment-customer-info v-if="!!shipmentData" :receiver="shipmentData.deliver.receiver" />
  <shipment-summary v-if="!!shipmentData" :packages="shipmentData.packages" :origin-entity-id="shipmentData.origin_entity_id" :origin-entity-type="shipmentData.origin_entity_type" />
</template>

<script>

import ShipmentCustomerInfo from "./ShipmentCustormerInfo.vue"
import ShipmentSummary from "./ShipmentSummary.vue"
import ShipmentTracking from "./ShipmentTracking.vue";


export default {
  name: "ShipmentFooter",
  components: {
    ShipmentCustomerInfo,
    ShipmentSummary,
    ShipmentTracking
  },
  props: {
    shipmentData: {
      type: Object,
      default: null,
    },
  },  
  data() {
    return {};
  },
};

</script>